import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { isEmpty } from '@semios/app-platform-common'
import { apiFetch } from 'utils/apiFetch'
import { unitConverter } from 'utils/unitConverter/unitConverter'
import type { TGetCacheUpdatesFromResponseParameters, TGetCacheUpdatesFromResponseReturn } from './_types'
import { generateGetWindCacheUpdatesFromResponse } from './_utils/generateGetWindCacheUpdatesFromResponse'
import { generateWindAPIArgs } from './_utils/generateWindAPIArgs'

const baseUnitConverter = unitConverter.windSpeed
const heatmapExtremesForAllPropertiesInVisibleRegions = true

const makeApiArgs = (
  processedCaches: TGetCacheUpdatesFromResponseParameters['processedCaches'],
): routes.ValuesCurrent.Request => {
  return generateWindAPIArgs({
    heatmapExtremesForAllPropertiesInVisibleRegions,
    processedCaches,
    outOfBlockPoint: {
      windSpeedValueType: 'windSpeed_mps',
      windDirectionValueType: 'windDirection_degrees',
    },
    inBlockPoint: {
      windSpeedValueType: 'windSpeed_mps',
      windDirectionValueType: 'windDirection_degrees',
    },
    property: {
      windSpeedValueType: 'windSpeed_minMedianMax_mps',
      windDirectionValueType: 'windDirection_average_degrees',
    },
    region: {
      windSpeedValueType: 'windSpeed_minMedianMax_mps',
      windDirectionValueType: 'windDirection_average_degrees',
    },
  })
}

export const getResponseAndShapeForCacheUpdate = async ({
  cacheKeys,
  processedCaches,
}: TGetCacheUpdatesFromResponseParameters): Promise<TGetCacheUpdatesFromResponseReturn> => {
  const args = makeApiArgs(processedCaches)

  if (isEmpty(args)) return {}

  const response = await apiFetch({ url: '/values-current', body: args })

  return generateGetWindCacheUpdatesFromResponse({
    cacheKeys,
    heatmapExtremesForAllPropertiesInVisibleRegions,
    processedCaches,
    response,
    outOfBlockPoint: {
      windSpeedValueType: 'windSpeed_mps',
      windDirectionValueType: 'windDirection_degrees',
      unitConverterFunction: baseUnitConverter,
    },
    inBlockPoint: {
      windSpeedValueType: 'windSpeed_mps',
      windDirectionValueType: 'windDirection_degrees',
      unitConverterFunction: baseUnitConverter,
    },
    property: {
      windSpeedValueType: 'windSpeed_minMedianMax_mps',
      windDirectionValueType: 'windDirection_average_degrees',
      unitConverterFunction: baseUnitConverter,
    },
    region: {
      windSpeedValueType: 'windSpeed_minMedianMax_mps',
      windDirectionValueType: 'windDirection_average_degrees',
      unitConverterFunction: baseUnitConverter,
    },
  })
}
